import axios from 'axios';
import { i18n } from '@/plugins/i18n';
import * as toastr from 'toastr';
import { doAsync } from '@/utils/async';
import {
  SEND_MESSAGE,
} from '@/store/modules/socket/action-types';
import SocketMessages from '@/utils/classes/SocketMessages';
import * as actionsTypes from './action-types';
import * as mutationsTypes from './mutation-types';


export default {
  async [actionsTypes.FETCH_NAVIGATION_LIST](store) {
    return doAsync(store, {
      config: {
        method: 'get',
        url: '/server/navigation/get.php',
      },
      mutationTypes: mutationsTypes.GET_NAVIGATION_LIST,
      callback: response => (response.data instanceof Array ? response.data : []),
    })
      .catch(() => {
        toastr.error(i18n.t('message.CONNECTION_ERROR'));
      });
  },

  async [actionsTypes.SET_NAVIGATION_ITEM](store, payload) {
    const { cancelCallback } = payload;
    delete payload.cancelCallback;
    return doAsync(
      store,
      {
        config: {
          method: 'post',
          url: '/server/navigation/set.php',
          data: payload,
        },
        mutationTypes: mutationsTypes.GET_NAVIGATION_LIST,
        callback: (response) => {
          if (response.data instanceof Array) {
            return response.data;
          }
          throw response;
        },
      },
      cancelCallback,
    )
      .then((result) => {
        store.dispatch(`socket/${SEND_MESSAGE}`, SocketMessages.NAV_LIST_CHANGE, { root: true });
        return result;
      })
      .catch((err) => {
        if (!axios.isCancel(err) && (!err.response || err.response.status !== 401)) {
          toastr.error(i18n.t('message.CONNECTION_ERROR'));
        }
      });
  },

  async [actionsTypes.DELETE_NAVIGATION_ITEM](store, payload) {
    return doAsync(store, {
      config: {
        method: 'post',
        url: '/server/navigation/delete.php',
        data: payload,
      },
      mutationTypes: mutationsTypes.GET_NAVIGATION_LIST,
      callback: response => (response.data instanceof Array ? response.data : []),
    })
      .then((result) => {
        store.dispatch(`socket/${SEND_MESSAGE}`, SocketMessages.NAV_LIST_CHANGE, { root: true });
        return result;
      })
      .catch((error) => {
        if (!error.response || error.response.status !== 401) {
          toastr.error(i18n.t('message.CONNECTION_ERROR'));
        }
      });
  },

  async [actionsTypes.RESET_NAVIGATION_LIST](store) {
    return doAsync(store, {
      config: {
        method: 'post',
        url: '/server/navigation/reset.php',
      },
      mutationTypes: mutationsTypes.GET_NAVIGATION_LIST,
      callback: response => (response.data instanceof Array ? response.data : []),
    })
      .then((result) => {
        store.dispatch(`socket/${SEND_MESSAGE}`, SocketMessages.NAV_LIST_CHANGE, { root: true });
        return result;
      })
      .catch((error) => {
        if (!error.response || error.response.status !== 401) {
          toastr.error(i18n.t('message.CONNECTION_ERROR'));
        }
      });
  },
};
